import React, { useEffect, useState } from "react";
import { Grid } from "@material-ui/core";
import Axios from "axios";
import Modal from "react-responsive-modal";
import { ReportSectionHeader } from "../../common/components/SectionHeader";
import { HeaderDivider } from "../../common/components/HeaderDivider";
import { apiUri } from "../../config";
import {
  NotificationManager,
  NotificationContainer,
} from "react-notifications";
import "react-notifications/lib/notifications.css";
import { withRouter } from "react-router-dom";

const AceTypeOption = ({ title, subTitle, ...rest }) => (
  <div>
    <input type="radio" name="aceType" {...rest} />
    <label htmlFor="aceType" className="sar-input-label">
      {title} <small>&nbsp;&nbsp;{subTitle && `(${subTitle})`}</small>
    </label>
  </div>
);

function AceTypeSelection({
  handleNext,
  user,
  setSelectedAceType,
  setPurchaseLimit,
  history,
}) {
  const [aceType, setAceType] = useState("");
  const [freePurchaseLimit, setFreePurchaseLimit] = useState("1");
  const [paidPurchaseLimit, setPaidPurchaseLimit] = useState("10");
  // const [showContactInfo, setShowContactInfo] = useState(false);

  const handleAceTypeSelection = (e) => {
    setAceType(e.target.value);
    // if (e.target.value === "Bulk") {
    //   setShowContactInfo(true);
    // }
  };
  const handleSaveACEType = () => {
    Axios.put(
      `${apiUri}/register/saveAceType/${user.registrationUuid}/${aceType}`
    )
      .then((res) => {
        if (res.status === 200) {
          if (aceType !== "3") {
            setSelectedAceType(aceType);
            setPurchaseLimit(
              aceType === "1" ? freePurchaseLimit : paidPurchaseLimit
            );
            handleNext();
          } else {
            history.push({ pathname: "/Thankyou", state: { user: user } });
          }
        }
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(err.message, "Failure");
      });
  };

  const fetchPurcheLimitForAceType = () => {
    Axios.get(`${apiUri}/register/purchaseLimit?type=paid`)
      .then((res) => {
        if (res.data.statusCode === 200 && res.data.content.purchaseLimit) {
          setPaidPurchaseLimit(res.data.content.purchaseLimit);
        }
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(err.message, "Failure");
      });
    Axios.get(`${apiUri}/register/purchaseLimit?type=free`)
      .then((res) => {
        if (res.data.statusCode === 200 && res.data.content.purchaseLimit) {
          setFreePurchaseLimit(res.data.content.purchaseLimit);
        }
      })
      .catch((err) => {
        console.log(err);
        NotificationManager.error(err.message, "Failure");
      });
  };

  useEffect(() => {
    fetchPurcheLimitForAceType();
  }, []);

  // const handleOnCloseModal = () => {
  //   setAceType("");
  //   setShowContactInfo(false);
  // };

  // const modelProps = { showContactInfo, handleOnCloseModal };
  return (
    <Grid container justify="center">
      <Grid item xs={12} sm={8} md={6}>
        <div style={{ margin: "0 8%", minHeight: 500 }}>
          <ReportSectionHeader>
            <h4>Select ACE Alert&reg; Subscription</h4>
          </ReportSectionHeader>
          <br />
          <HeaderDivider />
          <br />

          <AceTypeOption
            value="1"
            checked={aceType === "1"}
            title="ACE Alert\u00AE Subscription – Trial"
            onChange={handleAceTypeSelection}
          />
          <p className="aceTypeSubtitle">
            Select this option to receive an ACE Alert&reg; on any one of{" "}
            {freePurchaseLimit} selected publicly-traded companies on the NYSE
            or NASDAQ at no cost. This trial subscription will provide the trial
            subscriber with the first ACE Alert&reg; that is triggered for any of the
            selected companies. Upon receiving the first ACE Alert&reg;, the trial
            subscription will end, and the trial subscriber will have the option
            to continue receiving ACE Alert&reg; notifications by paying the annual subscription
            fee for an Executive or Corporate ACE Alert&reg; Subscription service.
            Can select only company
          </p>

          <AceTypeOption
            value="2"
            checked={aceType === "2"}
            title="ACE Alert&reg; Subscription – Executive"
            onChange={handleAceTypeSelection}
          />
          <p className="aceTypeSubtitle">
            Select this option to receive ACE Alert&reg; notifications for up to{" "}
            {paidPurchaseLimit} public companies for the licensing fee of $4,000
            per company. The ACE Alert&reg; Subscripion will provide the Execuive
            Subscriber with ACE Alert&reg; notifications that are triggered during a full calendar
            year (252 trading days). Subscribers will have access to the SAR
            Platorm, which includes the SAR Risk Dashboard for the target
            company flagged with an ACE Alert&reg;, and the SAR Risk Score&reg; for each
            selected company.
          </p>

          <br />
          <br />

          <div className="right">
            <button
              className="sar-btn"
              disabled={!aceType}
              onClick={handleSaveACEType}
            >
              Next
            </button>
          </div>
        </div>
      </Grid>
      <NotificationContainer />

      {/* <ContactUsModel {...modelProps} /> */}
    </Grid>
  );
}

export default withRouter(AceTypeSelection);

// function ContactUsModel({ showContactInfo, handleOnCloseModal }) {
//   return (
//     <Modal open={showContactInfo} onClose={handleOnCloseModal}>
//       <div className="ModalWindow">
//         <p>Contact info goes here...</p>
//         <div className="right">
//           <button className="sar-btn" onClick={handleOnCloseModal}>
//             Close
//           </button>
//         </div>
//       </div>
//     </Modal>
//   );
// }



// WEBPACK FOOTER //
// ./src/components/Register/aceType.jsx